var OCS = OCS || {};
OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Interfaces = OCS.WxBriefing.Interfaces || {};
OCS.WxBriefing.Functions = OCS.WxBriefing.Functions || {};
OCS.WxBriefing.Functions.define_mobile_vertical_menu_interface = function () {
    return {
        activate: function () {
            this.parent();
            this.ul_element.setStyles({'height': '100%', 'display': 'none'});
            //var height = this.ul_element.getDimensions();
            this.ul_trans.set({display: 'block'}).start({'height': [0, 100]});

        },
        deactivate: function () {
            this.parent();
            this.ul_trans.start({'height': 0}).set({'display': 'none'});


        }
    };
};
OCS.WxBriefing.Interfaces.MobileVerticalMenu = OCS.WxBriefing.Functions.define_mobile_vertical_menu_interface();